
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prestorming-online-thankyou",
      function () {
        return require("private-next-pages/prestorming-online-thankyou/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prestorming-online-thankyou"])
      });
    }
  